/**
 * CDB54 Calendrier+ - Pinia Store Configuration
 * Centralizes Pinia store setup
 */

import { createPinia } from 'pinia';

const pinia = createPinia();

export default pinia;
